module.exports = __webpack_public_path__ + "img/quest_icon_0066_share.68cbf8e1.png";